import { useLocation } from "react-router-dom";

export const getEmbeddedContentFromResponse = (_embedded) => {
    return _embedded?.content;
  };
  
  export const extractData = (result, isEmbeddedContent = true) => {
    
    let modifiedResult = {
      ...result,
      content: getEmbeddedContentFromResponse(result?._embedded),
    };
    delete modifiedResult._embedded;
    return modifiedResult;
  };
  export const useQuery = ()=> {
    return new URLSearchParams(useLocation().search);
  }
  export const removeWordAfterAt = (str)=> {
    if (!str || str === 'null' || str === 'undefined') {
      return '';
    }
    let parts = str.split('@');
    let result = '';
    if (parts.length <= 1 || parts[1] === "") {
      result = str;
    } else {
      result = parts[0];
    }

    if (result.length > 0) {
      result = result.charAt(0).toUpperCase() + result.slice(1);
    }
    
    return result;
  }

  export const formatDates = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('/');
  };
  export const formatDatesHyphan = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  };

  export const formatDatesMMDDYYYYY = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [month, day, year].join('/');
  };

  export const getCurrentAndThreeDaysLater = () => {
    const currentDate = new Date();
    const threeDaysLater = new Date(currentDate);
    threeDaysLater.setDate(currentDate.getDate() + 3);
    return { currentDate, threeDaysLater };
  };

  export const formatDatesMmDdYyyy = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return dateStr ?? "";
    const [year, month, day] = dateStr.split("-");
    return `${month}/${day}/${year}`;
  };

  export const formatAmount = (val) => Number(val ?? 0).toFixed(2);